export default "__VITE_ASSET__BFJuqBbp__"